import OnlineDeliveryWarningModal from './OnlineDeliveryWarningModal';

export default OnlineDeliveryWarningModal;
